import * as parent from '../../variables';

export const colors = {
  ...parent.colors
};
export const fonts = parent.fonts;
